import { CarTitleStyled } from './CarTitleStyled';
import { SC } from '../../styles/theme';
import { IFinanceQuote } from '../../services/calculateSummary/calculateSummary.types';

export interface CarTitleProps extends SC {
    title: string;
}

const CarTitle = (props: CarTitleProps) => {
    return <CarTitleStyled {...props} />;
};

export default CarTitle;
